import { render, staticRenderFns } from "./TableCreator.vue?vue&type=template&id=18e408b1&scoped=true&"
import script from "./TableCreator.vue?vue&type=script&lang=js&"
export * from "./TableCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e408b1",
  null
  
)

export default component.exports